<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BookingBreadcrumb',
  mixins: [baseMixin],
  props: {
    editMode: { type: Boolean, default: false },
    subTitle: { type: String, default: '' },
  },
}
</script>

<template>
  <div class="d-flex booking-breadcrumb">
    <div
      class="d-flex back-action"
      data-test-btn="back-action"
      @click="$emit('backClicked')"
    >
      <v-icon size="20">mdi-chevron-left</v-icon>
      <span>{{ $t('general.back') }}</span>
    </div>
    <span class="breadcrumb-heading">{{
      editMode ? $t('bookingEdit.pageTitle') : $t('bookingCreate.pageTitle')
    }}</span>
    <span v-if="subTitle" class="breadcrumb-sub-heading">{{ subTitle }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';

.booking-breadcrumb {
  height: 24px;
  gap: 16px;

  .back-action {
    width: 57px;
    height: 24px;
    gap: 2px;
    cursor: pointer;

    .v-icon {
      color: $color-neutral-grey-400 !important;
    }
    span {
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      color: $color-gray-550 !important;
      letter-spacing: 0.15px;
    }
  }
  .breadcrumb-heading,
  .breadcrumb-sub-heading {
    font-size: 16px;
    font-weight: 500;
    color: $color-grey-700 !important;
  }
}
</style>
